<template>
  <div class="sn-f-col-b-s record-info">
    <sn-breadcrumb :breadcrumb="[{
      title: '挂号预约记录',
      replace: true,
      router: '/appointment/record',
    }, {
      title: appointmentContent + '结果'
    }]"></sn-breadcrumb>
    <div class="sn-f-1 sn-f-col-b-c record-info-region">
      <template v-if="recordInfo.appointId">
        <div class="sn-f-1 entire">
          <div class="sn-f-b-e sn-title">
            <div class="sn-f-c-c title-caption">医生信息</div>
          </div>
          <div class="sn-f-b-c doctor">
            <sn-head-photo :src="$sn.format.getQuality(recordInfo, 'doctor.doctorPicture')" :width="120" :height="160"></sn-head-photo>
            <div class="sn-f-1 sn-f-col-b-s doctor-info">
              <div class="sn-f-s-c">
                <div class="sn-fs-32 sn-fw-bold">{{ recordInfo.doctorName }}</div>
                <div class="sn-f-col-c-s doctor-sub" v-if="recordInfo.deptName || appointment_mixin_formatRecordDoctorTitle({
                  ...recordInfo,
                  doctorTitle: $sn.format.getQuality(recordInfo, 'doctor.doctorTitle')
                })">
                  <div v-if="recordInfo.deptName">{{ recordInfo.deptName }}</div>
                  <div v-if="appointment_mixin_formatRecordDoctorTitle({
                    ...recordInfo,
                    doctorTitle: $sn.format.getQuality(recordInfo, 'doctor.doctorTitle')
                  })">{{ appointment_mixin_formatRecordDoctorTitle({
                    ...recordInfo,
                    doctorTitle: $sn.format.getQuality(recordInfo, 'doctor.doctorTitle')
                  }) }}</div>
                </div>
              </div>
              <div class="sn-f-1 doctor-caption">
                <div>医生介绍：&nbsp;&nbsp;{{ $sn.format.getQuality(recordInfo, 'doctor.doctorIntroduce') || '暂无' }}</div>
                <div>医生擅长：&nbsp;&nbsp;{{ $sn.format.getQuality(recordInfo, 'doctor.doctorSkill') || '暂无' }}</div>
              </div>
            </div>
          </div>
          <div class="sn-f-b-e sn-title">
            <div class="sn-f-c-c title-caption">预约信息</div>
          </div>
          <div class="record">
            <div class="sn-f-s-c record-line sn-fc-red1" v-if="isShowScheduleCostAppointment && parseFloat(recordInfo.regFee) > 0">
              <div>挂号费用：</div>
              <div>¥{{ recordInfo.regFee }}</div>
            </div>
            <div class="sn-f-s-c record-line" v-if="$sn.format.getQuality(separateCaption, 'AREA.' + recordInfo.deptId)">
              <div>就诊院区：</div>
              <div>{{ $sn.format.getQuality(separateCaption, 'AREA.' + recordInfo.deptId) }}</div>
            </div>
            <div class="sn-f-s-c record-line">
              <div>就诊地点：</div>
              <div>
                <template  v-if="$sn.format.getQuality(separateCaption, 'ADDRESS.' + recordInfo.deptId + '.TITLE')">
                  {{ $sn.format.getQuality(separateCaption, 'ADDRESS.' + recordInfo.deptId + '.TITLE') }}
                  <template v-if="$sn.format.getQuality(separateCaption, 'ADDRESS.' + recordInfo.deptId + '.SUB')">
                    &nbsp;-&nbsp;{{ $sn.format.getQuality(separateCaption, 'ADDRESS.' + recordInfo.deptId + '.SUB') }}
                  </template>
                </template>
                <template v-else>
                  {{ $sn.utils.getHospitalTitle() }}
                  <span class="sn-fc-main" v-if="isHosArea && selectedArea.areaName">[{{selectedArea.areaName}}]</span>
                  <template v-if="selectedArea.address">
                    &nbsp;-&nbsp;{{ selectedArea.address }}
                  </template>
                </template>
              </div>
            </div>
            <div class="sn-f-s-c record-line" v-if="$sn.getConfig('isShowDepartPositionAppointment') && recordInfo.appointAddress">
              <div>科室地址：</div>
              <div>{{ recordInfo.appointAddress }}</div>
            </div>
            <div class="sn-f-s-c record-line">
              <div>{{ $sn.getConfig('appointmentTimeContent') }}：</div>
              <div>
                {{ recordInfo.schDate + '（周' +  $sn.format.day(recordInfo.schDate) + '）'}}
                <template v-if="$sn.getConfig('isScheduleTimeSerialPostPosition')">
                  {{recordInfo.schTime}}
                  <template v-if="isShowTimeSerialAfterAppointment && recordInfo.state === 1 && recordInfo.schSeq">
                    [{{ recordInfo.schSeq }}]
                  </template>
                </template>
                <template v-else>
                  <template v-if="isShowTimeSerialAfterAppointment && recordInfo.state === 1 && recordInfo.schSeq">
                    <span class="sn-fw-bold">{{ recordInfo.schSeq }}</span>[
                  </template>
                  {{ recordInfo.schTime }}
                  <template v-if="isShowTimeSerialAfterAppointment && recordInfo.state === 1 && recordInfo.schSeq">]</template>
                </template>
              </div>
            </div>
            <div class="sn-f-s-c record-line" v-if="recordInfo.schSeq &&
            ((isShowTimeSerialOnAppointmentRecord === 1 && parseFloat(recordInfo.schSeq) >= 0) ||
            (isShowTimeSerialOnAppointmentRecord === 2 && recordInfo.state === 1 && parseFloat(recordInfo.schSeq) >= 0) ||
            (isShowTimeSerialOnAppointmentRecord === 4 && recordInfo.state === 1))">
              <div>排队序号：</div>
              <div>{{recordInfo.schSeq}}</div>
            </div>
            <div class="sn-f-s-c record-line">
              <div><span style="letter-spacing: 0.5em;">就诊</span>人：</div>
              <div>{{ $sn.encrypted.name(recordInfo.patientName) }}</div>
            </div>
            <div class="sn-f-s-c record-line" v-if="isOpenCardManage && outCardSerial && $sn.utils.getHospitalId() !== perpetual.HOSPITAL_ID_SDSL">
              <div><span style="letter-spacing: 0.5em;">就诊</span>卡：</div>
              <div>{{ outCardSerial }}</div>
            </div>
            <div class="sn-f-s-c record-line" v-if="selectedPatient.patientIdCardNo">
              <div><span style="letter-spacing: 0.5em;">证件</span>号：</div>
              <div>{{ $sn.encrypted.idCardSerial(selectedPatient.patientIdCardNo) }}</div>
            </div>
            <div class="sn-f-s-c record-line" v-if="recordInfo.patientPhone">
              <div><span style="letter-spacing: 0.5em;">手机</span>号：</div>
              <div>{{ recordInfo.patientPhone }}</div>
            </div>
          </div>
          <div class="sn-prompt" v-if="promptInfo.length > 0">
            <div class="sn-prompt-title">温馨提示</div>
            <div class="sn-f-s-s sn-prompt-caption" :class="item.type === '2' ? 'sn-fc-red1 ' + item.style : item.style" :key="i" v-for="(item, i) in promptInfo">
              <div class="sn-prompt-star">★</div>
              <div v-html="item.info"></div>
            </div>
          </div>
        </div>
        <div class="sn-f-c-c bottom-blank" v-if="formatBottomBlankCondition(recordInfo)">
          <div class="sn-f-c-c sn-pointer interaction sn-bc-background1 sn-fc-text1"
          v-if="appointment_mixin_verifyCancelAppointmentInteraction(recordInfo)" @click="() => {
            $set(recordInfo, 'params', {
              type: '0'
            });
            exhibitionRecordCancel = true;
          }">{{ '取消' + appointmentContent }}</div>
          <template v-if="$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_QDQL">
            <template v-if="recordInfo.state === 1 && recordInfo.hosState === 5 && recordInfo.isDopay === 1">
              <div class="sn-f-c-c sn-pointer interaction sn-bc-background1 sn-fc-text1" @click="() => {
                $set(recordInfo, 'params', {
                  type: '1'
                });
                exhibitionRecordCancel = true;
              }">申请退款</div>
            </template>
          </template>
          <template v-if="recordInfo.doctorTitle !== '普通'">
            <template v-if="(recordInfo.state === 1 && recordInfo.hosState !== 0) || recordInfo.state === 2">
              <div class="sn-f-c-c sn-pointer interaction" @click="homepage_mixin_navigateUrl('/appointment/doctor', recordInfo);">{{ '再次' + appointmentContent }}</div>
            </template>
          </template>
          <div class="sn-f-c-c sn-pointer interaction"
          v-if="appointment_mixin_verifyPayPromptInteraction(recordInfo)" @click="appointment_mixin_payRecordHandle({
            record: recordInfo,
            patient: selectedPatient
          });">
            立即支付<template v-if="appointment_mixin_verifyPayRestrictTimeCaption(recordInfo)">&nbsp;({{recordInfo.time}})&nbsp;</template>
          </div>
          <template v-if="isOpenDeleteAppointmentRecord">
            <div class="sn-f-c-c sn-pointer interaction"
            :class="{'sn-bc-red1 sn-fc-white': $sn.format.date($sn.utils.getCurrentTime(), 'yyyy-MM-dd') >= $sn.format.date(recordInfo.schDate, 'yyyy-MM-dd', restrictAppointmentRecordDeleteDate, 'day'),
            'sn-bc-background1 sn-fc-text6': $sn.format.date($sn.utils.getCurrentTime(), 'yyyy-MM-dd') < $sn.format.date(recordInfo.schDate, 'yyyy-MM-dd', restrictAppointmentRecordDeleteDate, 'day')}"
            @click="appointment_mixin_navigateUrl('delete', recordInfo);">删除</div>
          </template>
        </div>
      </template>
      <sn-no-data message="暂未查询到该条预约记录，请稍后重试" v-else></sn-no-data>
    </div>
    <pay-result v-if="exhibitionPayResult" :params="payResultParams" @sendBack="sendBackPayResult">
      <template v-slot:result>
        <div class="sn-f-col-s-c result-slot">
          <div class="sn-f-s-c result-line">
            <div><span style="letter-spacing: 0.5em;">就诊</span>人：</div>
            <div class="sn-f-1 sn-omit">{{ selectedPatient.patientName }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>
              <template v-if="$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL">
                <span style="letter-spacing: 0.5em;">证件</span>号：
              </template>
              <template v-else>
                <span style="letter-spacing: 0.5em;">就诊</span>卡：
              </template>
            </div>
            <div class="sn-f-1 sn-omit">{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? selectedPatient.idCardEncrypt : recordInfo.patientCardId }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>支付单号：</div>
            <div class="sn-f-1 sn-omit">{{ Object.values(payResultParams.pay)[0].serial }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>支付金额：</div>
            <div class="sn-f-1 sn-omit">{{ payResultParams.cost }}</div>
          </div>
        </div>
      </template>
    </pay-result>
    <record-cancel v-if="exhibitionRecordCancel" :record="recordInfo" @sendBack="sendBackRecordCancel"></record-cancel>
    <pay-pattern v-if="exhibitionPayPattern" :params="payPatternParams" @sendBack="appointment_mixin_sendBackPayPattern"></pay-pattern>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger.js';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';
import * as Initial from '@/common/utils/initial';

export default {
  mixins: [HomepageMixin, AppointmentMixin],
  components: {
    'record-cancel': () => import('@/pages/appointment/record-cancel'),
    'pay-pattern': () => import('@/components/pay-pattern'),
    'pay-result': () => import('@/components/pay-result')
  },
  data() {
    return {
      pageParams: {},
      recordInfo: {},
      selectedArea: {},
      selectedPatient: {},
      outCardSerial: '',
      recordInterval: null,
      isShowTimeSerialAfterAppointment: self.$sn.getConfig('isShowTimeSerialAfterAppointment'),
      isOpenDeleteAppointmentRecord: self.$sn.getConfig('isOpenDeleteAppointmentRecord'),
      //
      exhibitionRecordCancel: false
    };
  },
  created: async function() {
    this.pageParams = this.$route.query;
    document.title = this.appointmentContent + '结果';
    this.$route.meta.title = this.appointmentContent + '结果';
    this.appointment_mixin_getSeparateCaption();
    if (this.pageParams.id) {
      if (this.$sn.utils.getHospitalSessionStorage('Appointment_RecordInfo')) {
        this.$sn.utils.removeHospitalSessionStorage('Appointment_RecordInfo');
      }
      await this.getRecord(this.pageParams.id);
    }
    else {
      if (this.$sn.utils.getHospitalSessionStorage('Appointment_RecordInfo')) {
        this.recordInfo = this.$sn.utils.getHospitalSessionStorage('Appointment_RecordInfo');
      }
    }
    this.formatRecordInfo();
  },
  methods: {
    getRecord(id) {
      return new Promise(resolve => {
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest({
          url: this.$sn.format.caption(Swagger.getAppointmentInfoByCondition, [this.$sn.utils.getPlatformType(), this.$sn.utils.getProjectType()]),
          method: 'POST',
          header: true,
          data: JSON.stringify({
            appointId: id,
            hosId: this.$sn.utils.getHospitalId(),
            page: 0,
            size: this.perpetual.PAGINATION_SIZE,
            userId: this.$sn.utils.getOpenId()
          })
        }).then(result => {
          this.$sn.assembly.loading(false);
          let record = {};
          if (result && result.code === 0 && result.data && result.data.length > 0) record = result.data[0];
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_YTS) {
            if (record.schId && record.schId.substring(0, 5) === '21353') {
              record.doctorName = '儿童入园健康检查';
            }
          }
          this.recordInfo = record;
          resolve(record);
        });
      });
    },
    async formatRecordInfo() {
      if (this.recordInfo.appointId) {
        if (this.recordInfo.hosArea) {
          this.selectedArea = this.$sn.utils.getHospitalAreaInformation(this.recordInfo.hosArea);
        }
        else {
          this.selectedArea = this.$sn.utils.getHospitalAreaInformation()[0];
        }
        if (this.recordInfo.patientCardId) {
          this.outCardSerial = this.recordInfo.patientCardId;
        }
        this.appointment_mixin_getPromptInfo({
          outCardSerial: this.outCardSerial,
          ...this.recordInfo
        });
        this.formatRecordInfoInterval();
        // 处理当前记录就诊人信息
        Initial.obtainPatientInfoByCondition().then(() => {
          let storage = [];
          if (this.$sn.utils.getHospitalLocalStorage('Login_PatientList') && this.$sn.utils.getHospitalLocalStorage('Login_PatientList').length > 0) {
            storage = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
          }
          const match = storage.find(result => result.patientId === this.recordInfo.patientId);
          if (!this.$sn.validate.empty(match)) {
            this.selectedPatient = match;
            if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
              if (this.selectedPatient.idCardType) {
                this.recordInfo.idcardtype = this.selectedPatient.idCardType;
              }
            }
          }
        });
        // 处理当前记录医生信息
        this.homepage_mixin_getDoctorInfoByCondition(this.recordInfo).then(doctor => {
          if (doctor.code === 0) {
            let serial = doctor.data.findIndex(result => result.doctorId === this.recordInfo.doctorId && result.deptId === this.recordInfo.deptId);
            if (serial === -1) serial = 0;
            this.$set(this.recordInfo, 'doctor', doctor.data[serial]);
          }
        });
      }
    },
    formatRecordInfoInterval() {
      if (this.restrictAppointmentRecordPayTime > 0 || this.restrictTodayRegisterRecordPayTime > 0) {
        if (this.recordInterval) {
          clearInterval(this.recordInterval);
          this.recordInterval = null;
        }
        if (this.recordInfo.state === 1 && this.recordInfo.hosState === 0 && this.recordInfo.candidateFlag !== '1') {
          if (this.recordInfo.isDopay === 0 && this.recordInfo.regFee && parseFloat(this.recordInfo.regFee) > 0) {
            if (this.recordInfo.patientCardId) {
              if ((this.recordInfo.isToday === 0 && this.restrictAppointmentRecordPayTime > 0) || (this.recordInfo.isToday === 1 && this.restrictTodayRegisterRecordPayTime > 0)) {
                if (this.appointment_mixin_compareAppointmentRecordPayTime(this.recordInfo)) {
                  this.recordInterval = setInterval(() => {
                    if (parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(this.recordInfo.opTime).getTime() / 1000 < (this.recordInfo.isToday === 0 ? this.restrictAppointmentRecordPayTime : this.restrictTodayRegisterRecordPayTime)) {
                      this.$set(this.recordInfo, 'time', '');
                      let value = 0;
                      if (parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(this.recordInfo.opTime).getTime() / 1000 > 0) {
                        value = parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(this.recordInfo.opTime).getTime() / 1000;
                      }
                      this.appointment_mixin_formatTime((this.recordInfo.isToday === 0 ? this.restrictAppointmentRecordPayTime : this.restrictTodayRegisterRecordPayTime) - value, this.recordInfo);
                    }
                    else {
                      this.recordInfo.state = 2;
                    }
                  }, 1 * 1000);
                }
              }
            }
          }
        }
      }
    },
    formatBottomBlankCondition(record) {
      let value = 0;
      if (record && record.appointId) {
        if (this.appointment_mixin_verifyCancelAppointmentInteraction(record)) {
          value++;
        }
        if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDQL) {
          if (record.state === 1 && record.hosState === 5 && record.isDopay === 1) {
            value++;
          }
        }
        if (record.doctorTitle !== '普通') {
          if ((record.state === 1 && record.hosState !== 0) || record.state === 2) {
            value++;
          }
        }
        if (this.appointment_mixin_verifyPayPromptInteraction(record)) {
          value++;
        }
        if (this.$sn.getConfig('isOpenDeleteAppointmentRecord')) {
          value++;
        }
      }
      return value > 0;
    },
    async sendBackPayResult(type, status) {
      if (!type) {
        if (status === 1) {
          this.recordInfo.isDopay = 1;
        }
        await this.getRecord(this.recordInfo.appointId);
        this.formatRecordInfo();
      }
      this.homepage_mixin_sendBackPayResult(type);
    },
    async sendBackRecordCancel(type) {
      if (type) {
        this.recordInfo.state = 2;
        await this.getRecord(this.recordInfo.appointId);
        this.formatRecordInfo();
      }
      this.exhibitionRecordCancel = false;
    }
  },
  beforeDestroy() {
    if (this.recordInterval) {
      clearInterval(this.recordInterval);
    }
  }
};
</script>
<style lang="scss" scoped>
.record-info {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    width: 100%;
    padding: 20px;

    .entire {
      overflow-x: hidden;
      overflow-y: auto;
      width: 100%;

      .doctor {
        width: 100%;
        height: 160px;
        margin: 20px 0;

        .sn-head-photo {
          margin-right: 10px;
        }

        &-info {
          height: 160px;

          .doctor-sub {
            @include fs(14);

            height: 100%;
            border-left: 1px solid $main3;
            padding-left: 10px;
            margin-left: 10px;
          }

          .doctor-caption {
            @include fs(14);

            overflow-x: hidden;
            overflow-y: auto;
            width: 100%;
            margin-top: 10px;

            div {
              margin-bottom: 10px;

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }

      .record {
        overflow: hidden;
        width: 100%;
        padding: 20px 0;

        &-line {
          @include fs(16);

          overflow: hidden;
          width: 100%;
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .bottom-blank {
      overflow: hidden;
      width: 100%;
      padding-top: 20px;

      .interaction {
        @include fs(14);

        overflow: hidden;
        width: 200px;
        height: 40px;
        background-color: $main3;
        color: $white;
        border-radius: 5px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
